var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2396 19.1329C17.8349 19.0062 18.1895 18.3703 17.8937 17.828C17.2415 16.6324 16.2142 15.5818 14.9 14.7811C13.2073 13.7499 11.1335 13.191 9 13.191C6.86652 13.191 4.79265 13.7499 3.10005 14.7811C1.78581 15.5818 0.758463 16.6324 0.106336 17.828C-0.189474 18.3703 0.165066 19.0062 0.76037 19.1329C6.19507 20.289 11.8049 20.289 17.2396 19.1329Z",
    fill: "#CAA91B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3843 5.49625C14.3843 8.53175 11.9737 10.9925 9 10.9925C6.02633 10.9925 3.6157 8.53175 3.6157 5.49625C3.6157 2.46076 6.02633 0 9 0C11.9737 0 14.3843 2.46076 14.3843 5.49625Z",
    fill: "#CAA91B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.287042fc628f2c86ed6faef08b7cfb1c.svg";
export { ForwardRef as ReactComponent };